import type { Query } from '@ab-core/graphql/dist';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { GET_REWARD_PRODUCTS } from './gql/getRewardProducts';

type QueryDataType = Pick<Query, 'getRewardProducts'>;
type OutgoingDataType = QueryDataType['getRewardProducts'];

const onError = getErrorLoggerFunction('getRewardProducts');

export const useGetRewardProducts = (offset?: number, limit?: number) => {
    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const { data, loading, refetch, error } = useQuery<QueryDataType>(GET_REWARD_PRODUCTS, {
        variables: {
            offset,
            limit
        },
        onError
    });

    useEffect(() => {
        if (data) {
            setOutgoingData(data.getRewardProducts);
        }
    }, [data]);

    return {
        data: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
